export interface ISimplePopup {
    setContent(content: string): void;
    open(): void;
}

declare global {
    interface Window {
        SimplePopup: {
            (): ISimplePopup;
            new (): ISimplePopup;
        };
    }
}

const simplePopup = window.SimplePopup;

export default simplePopup;
